import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ClientService } from 'src/app/core/services';

@Injectable({
    providedIn: 'root'
})
export class SwitchLanguageService {
    constructor(
        private readonly _transloco: TranslocoService,
        private readonly _client: ClientService
    ) {}

    switch(selectedLanguage: string, reloadWindow = true) {
        // store selectedLanguage in sessionStorage for use by APIs
        sessionStorage.setItem('selectedLanguage', selectedLanguage);

        // update HTML lang attribute for screen readers (always, even on reload)
        document.documentElement.lang = selectedLanguage;

        // reload page to call APIs with selected language
        if (reloadWindow) {
            window.location.reload();
        } else if (this._transloco.getActiveLang() != selectedLanguage) {
            this._transloco.setActiveLang(selectedLanguage);
            this._client.reload();
        }
    }
}
